export type FileViewerMode =
  | "default"
  | "analyze"
  | "promote"
  | "adjustPoints"
  | "summaryShare"
  | "annotate"
  | "extract";

/** Modes that morph the FileDetailModal shell to near-fullscreen. */
export const FOCUSED_WORKSPACE_MODES = [
  "promote",
  "analyze",
  "adjustPoints",
] as const satisfies ReadonlyArray<FileViewerMode>;

export type FocusedWorkspaceMode = (typeof FOCUSED_WORKSPACE_MODES)[number];

export function isFocusedWorkspaceMode(
  mode: FileViewerMode,
  isAnalyzePanelDetached = false,
): boolean {
  if (!(FOCUSED_WORKSPACE_MODES as readonly FileViewerMode[]).includes(mode)) {
    return false;
  }
  // Detached analyze returns the rail to Details — keep the shell compact.
  if (mode === "analyze" && isAnalyzePanelDetached) {
    return false;
  }
  return true;
}
